export default __webpack_public_path__ + "static/media/Sneakerswipe.10404048.lottie";